import { Grid } from "@mui/material";

export function AuthUIRootPages({ children }) {
  return (
    <div className="auth-container">
      <Grid>
        <Grid item sm={12} xs={12} className="auth-content-card">
          <img
            src="/assets/images/header-form-auth.webp"
            width="100%"
            height="100%"
            alt="header-form-auth images"
            loading="lazy"
          />
          {/* <Card className="">
            <h1>
              <u>Sedot Lur</u>
            </h1>
            <h2>Aplikasi Pendaftaran Penyedotan Septik Tank Online</h2>
          </Card> */}
          {/* auth-content-card auth-content-padding */}
        </Grid>
        <Grid item sm={12} xs={12}>
          {children}
        </Grid>
      </Grid>
    </div>
  );
}
